import { SVGProps, Ref, forwardRef } from 'react';

export const SendAndroidOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.446 22.595c-.949-.98-.283-3.03 1.047-7.129l.473-1.459c.323-.993.484-1.49.484-2.007s-.161-1.014-.484-2.007l-.473-1.46C1.163 4.435.497 2.385 1.446 1.406c.95-.978 2.744-.094 6.333 1.676L17.8 8.021C21.267 9.732 23 10.586 23 12s-1.733 2.27-5.2 3.978l-10.02 4.94c-3.59 1.77-5.385 2.655-6.334 1.677M17.004 9.636l-10.02-4.94c-1.855-.915-3.05-1.498-3.902-1.767a5 5 0 0 0-.279-.079c.008.143.03.344.081.62.188 1.003.639 2.406 1.321 4.508l.58 1.786L14.622 12l-9.837 2.236-.58 1.786c-.682 2.102-1.133 3.505-1.32 4.509a5 5 0 0 0-.082.619 5 5 0 0 0 .279-.08c.851-.268 2.047-.851 3.901-1.765l10.021-4.941c1.79-.883 2.94-1.455 3.667-1.962a3 3 0 0 0 .486-.402 3 3 0 0 0-.486-.402c-.728-.507-1.877-1.08-3.667-1.962"
                fill="currentColor"
            />
        </g>
    </svg>
));
SendAndroidOutlinedSize24Glyph.displayName = 'SendAndroidOutlinedSize24Glyph';
